module.exports = __webpack_public_path__ + "img/niuziyu.eee4869f.jpg";